import React, {Component} from 'react';
import '../static/styles/loading.scss'

const loading = require('../static/image/loading.gif');

interface Props {
}

interface State {
	isShowLoading: boolean
}

export default class Loading extends Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			isShowLoading: false
		};
		Loading.show = this.show.bind(this);
		Loading.hide = this.hide.bind(this);
	}

	static show;
	static hide;

	show() {
		this.setState({
			isShowLoading: true
		});
	}

	hide() {
		this.setState({
			isShowLoading: false
		});
	}

	componentDidMount() {
		let dom = document.getElementById("Loading");
		if (dom) {
			dom.ontouchmove = function (event) {
				event.preventDefault();
			}
		}
	}

	render() {
		return (
			<div id="Loading" className="back-shade" style={{display: this.state.isShowLoading ? 'flex' : 'none'}}>
				<div className="loading-body">
					<div className="loading">
						<div className="img">
							<img src={loading}/>
						</div>
						{/* <div className="text">正在加载</div> */}
					</div>
				</div>
			</div>
		)
	}

}
